import React from 'react';
import { Text, Section, Link } from '@react-email/components';
import Layout, { LayoutTranslations } from './components/Layout';

export interface PaymentConfirmedTranslations {
  title: string;
  greeting: string;
  body: string;
  labelAmount: string;
  labelReceipt: string;
  labelDate: string;
  labelLevel: string;
  access: string;
  ctaText: string;
  keepForPayment: string;
  signOff: string;
  teamSignature: string;
  layout: LayoutTranslations;
}

interface PaymentConfirmedProps {
  name: string;
  amount: string;
  receiptNumber: string;
  date: string;
  level: 'premium' | 'vip';
  translations: PaymentConfirmedTranslations;
}

export default function PaymentConfirmed({
  name,
  amount,
  receiptNumber,
  date,
  level,
  translations: tx,
}: PaymentConfirmedProps) {
  const levelLabel = level === 'vip' ? 'VIP' : 'Premium';

  return (
    <Layout previewText={`${tx.title} - ${amount}`} translations={tx.layout}>
      <Text style={heading}>{tx.title}</Text>
      <Text style={paragraph}>{tx.greeting} <strong>{name}</strong>,</Text>
      <Text style={paragraph}>{tx.body.replace('{{level}}', levelLabel)}</Text>

      <Section style={receiptBox}>
        <Text style={receiptLine}><span style={receiptLabel}>{tx.labelAmount}:</span> {amount}</Text>
        <Text style={receiptLine}><span style={receiptLabel}>{tx.labelReceipt}:</span> {receiptNumber}</Text>
        <Text style={receiptLine}><span style={receiptLabel}>{tx.labelDate}:</span> {date}</Text>
        <Text style={receiptLine}>
          <span style={receiptLabel}>{tx.labelLevel}:</span>{' '}
          <strong style={{ color: level === 'vip' ? '#d97706' : '#2563eb' }}>{levelLabel}</strong>
        </Text>
      </Section>

      <Text style={paragraph}>{tx.access.replace('{{level}}', levelLabel)}</Text>

      <Section style={ctaContainer}>
        <Link href="https://siportevent.com/visitor/dashboard" style={ctaButton}>{tx.ctaText}</Link>
      </Section>

      <Text style={footnote}>{tx.keepForPayment}</Text>
      <Text style={paragraph}>{tx.signOff}<br />{tx.teamSignature}</Text>
    </Layout>
  );
}

const heading: React.CSSProperties = { fontSize: '24px', fontWeight: 700, color: '#059669', margin: '0 0 20px 0' };
const paragraph: React.CSSProperties = { fontSize: '16px', lineHeight: '1.6', color: '#374151', margin: '0 0 16px 0' };
const receiptBox: React.CSSProperties = { backgroundColor: '#f3f4f6', padding: '20px', borderRadius: '8px', margin: '20px 0' };
const receiptLine: React.CSSProperties = { fontSize: '15px', color: '#1f2937', margin: '0 0 10px 0' };
const receiptLabel: React.CSSProperties = { color: '#6b7280' };
const ctaContainer: React.CSSProperties = { textAlign: 'center' as const, margin: '30px 0' };
const ctaButton: React.CSSProperties = { display: 'inline-block', padding: '14px 28px', backgroundColor: '#059669', color: '#ffffff', textDecoration: 'none', borderRadius: '8px', fontWeight: 600, fontSize: '16px' };
const footnote: React.CSSProperties = { fontSize: '13px', color: '#9ca3af', textAlign: 'center' as const, margin: '0 0 20px 0' };
